/**
 * Full-screen slide support: viewport-sized slides with .full-screen class.
 */

import { getVisibleViewportSize } from './viewport';

const DEFAULT_WIDTH = 1280;
const DEFAULT_HEIGHT = 720;

export function setupFullScreenSlides(): void {
  if (typeof Reveal === 'undefined' || typeof Reveal.getCurrentSlide !== 'function') return;
  const Rev = Reveal;

  function overrideFullScreenSection(): void {
    const s = Rev.getCurrentSlide?.();
    if (s && s.classList.contains('full-screen')) {
      s.style.setProperty('width', '100%', 'important');
      s.style.setProperty('height', '100%', 'important');
      s.style.setProperty('left', '0', 'important');
      s.style.setProperty('top', '0', 'important');
      s.style.setProperty('right', '0', 'important');
      s.style.setProperty('bottom', '0', 'important');
      s.style.setProperty('inset', '0', 'important');
      s.style.setProperty('transform', 'none', 'important');
      s.style.setProperty('margin', '0', 'important');
    }
  }

  function applyFullScreenSize(): void {
    const slide = Rev.getCurrentSlide?.();
    const isFullScreen = slide && slide.classList.contains('full-screen');
    const viewport = getVisibleViewportSize();
    const w = isFullScreen ? viewport.width : DEFAULT_WIDTH;
    const h = isFullScreen ? viewport.height : DEFAULT_HEIGHT;
    Rev.configure?.({
      width: w,
      height: h,
      margin: isFullScreen ? 0 : 0.04
    });
    if (typeof Rev.layout === 'function') Rev.layout();
    requestAnimationFrame(() => {
      overrideFullScreenSection();
      requestAnimationFrame(overrideFullScreenSection);
    });
  }

  Rev.on?.('ready', applyFullScreenSize);
  Rev.on?.('slidechanged', applyFullScreenSize);
  window.addEventListener('resize', () => {
    const s = Rev.getCurrentSlide?.();
    if (s && s.classList.contains('full-screen')) applyFullScreenSize();
  });
  if (window.visualViewport) {
    const onVv = (): void => {
      const s = Rev.getCurrentSlide?.();
      if (s && s.classList.contains('full-screen')) applyFullScreenSize();
    };
    window.visualViewport.addEventListener('resize', onVv, { passive: true });
    window.visualViewport.addEventListener('scroll', onVv, { passive: true });
  }
}
